import * as $ from "jquery";
import imkt from '../../imkt';
import url from '../../utils/url';

export default class PrototypeTabs {
  activeClass = "active";
  mobileSelectClassName = "imkt-ui-tabs--mobile__select";
  domRoot: JQuery<any>;
  params: any;
  menuLis: JQuery<HTMLElement>;
  menuLinks: JQuery<HTMLElement>;
  tabSections: JQuery<HTMLElement>;
  currentIndex: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = {
      // define default params here
      useScrolling: false,
      noDefault: false,
      useMobileSelect: false,
      ...params,
    };
    this.init();
  }

  init() {
    this.menuLis = $(".tab-menu > li", this.domRoot);
    this.menuLinks = $("a", this.menuLis);
    this.tabSections = $(".tab-content");

    this.menuLinks.filter("[data-additional-content]").each(function (i, el) {
      var tab = $(el);
      tab.data("additionalContent", $(tab.attr("data-additional-content")));
    });

    this.bindEvents();
    this.setInitialState();

    if (this.params.useMobileSelect) {
      this.initMobileSelect();
    }
  }

  activateByTabName(tabName: string) {
    var tabElement = this.menuLinks.filter("[data-name='" + tabName + "']");
    if (tabElement.length) {
      this.activateTab(tabElement);
    } else {
      this.activateTab(this.menuLinks.eq(0), true);
    }
  }

  activateByTabIndex(index: number) {
    this.activateTab(this.menuLinks.eq(index));
  }

  setInitialState() {
    var urlParams = url.getUrlParams();

    this.menuLinks.trigger("close.tab");

    if (!this.params.noDefault) {
      urlParams && urlParams.tab
        ? this.activateByTabName(urlParams.tab)
        : this.activateByTabIndex(0);
    }
  }

  bindEvents() {
    this.menuLinks
      .on("click", $.proxy(this.onclick_menuLink, this))
      .on("open.tab", $.proxy(this.onopen_tab, this))
      .on("close.tab", $.proxy(this.onclose_tab, this));
  }

  onclick_menuLink(e: MouseEvent) {
    e.preventDefault();
    this.activateTab($(e.currentTarget));
  }
  
  onopen_tab(e) {
    var additionalContent = $(e.currentTarget).data("additionalContent");
    if (additionalContent && additionalContent.length) {
      additionalContent.show();
    }
  }

  onclose_tab(e) {
    var additionalContent = $(e.currentTarget).data("additionalContent");
    if (additionalContent && additionalContent.length) {
      additionalContent.hide();
    }
  }

  updateHistory(tab: JQuery<HTMLElement>) {
    var tabName;

    if (imkt.core.supports.history()) {
      tabName = tab.attr("data-name");

      // Append url params from incoming URL on history state
      if (typeof tabName !== typeof undefined && tabName !== false) {
        var currentUrl = window.location.href;
        var urlParams = url.getUrlParams(currentUrl);

        if (urlParams) {
          urlParams["tab"] = tabName;
        } else {
          urlParams = { tab: tabName };
        }

        window.history.replaceState(
          tabName,
          document.title,
          "?" + $.param(urlParams) + window.location.hash
        );
      }
    }
  }

  checkScrollPosition() {
    var tabOffsetTop = this.domRoot.offset().top - 30;
    if ($(window).scrollTop() < tabOffsetTop) {
      $("body, html").scrollTop(tabOffsetTop);
    }
  }

  activateTab(tab: JQuery<HTMLElement>, skipHistory?: boolean) {
    var previousTab =
      typeof this.currentIndex === "number"
        ? this.menuLinks.eq(this.currentIndex)
        : null;

    if (tab.length && !tab.is(previousTab)) {
      this.menuLis.removeClass(this.activeClass);
      tab.closest("li").addClass(this.activeClass);

      this.tabSections.hide().filter(tab.attr("href")).show();

      this.currentIndex = this.menuLinks.index(tab);

      if (this.params.useScrolling) this.checkScrollPosition();

      if (previousTab) {
        previousTab.trigger("close.tab");
      }
      tab.trigger("open.tab");

      if (!skipHistory) {
        this.updateHistory(tab);
      }
    }
  }

  initMobileSelect() {
    var self = this;
    var select = document.createElement("select");
    select.className = this.mobileSelectClassName;

    $.each(this.menuLinks, function (i, link) {
      var option = document.createElement("option");
      var dataName = $(link).data("name");
      var dataAdditionalContent = $(link).data("additional-content");
      var value = $(link).text();

      $(option).data("name", dataName);
      $(option).data("additional-content", dataAdditionalContent);
      $(option).val(dataName);
      $(option).text(value);

      if ($(link).parent().hasClass("active")) {
        $(option).attr("selected", "selected");
      }

      $(select).append(option);
    });
    this.domRoot.prepend(select);

    $(select).on("change", function () {
      var index = $(this).find(":selected").index();
      self.activateTab(self.menuLinks.eq(index));
    });
  }
}
